import { render, staticRenderFns } from "./addDemo.vue?vue&type=template&id=3b64209a"
import script from "./addDemo.vue?vue&type=script&lang=js"
export * from "./addDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports